/**
 * Created by shoulm on 25/02/2018.
 */
export function reflect(promise){
    return promise.then((v)=>{ return {value:v, status: "resolved" }},
        (e)=>{ return {error:e, status: "rejected" }});
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/promiseReflect.ts